import { useEffect } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { useAuthModal } from "../context/AuthModalContext";

/**
 * Signed out: back to the last page they could see (Discover when they came
 * straight to this link) with the sign-in popup open; once signed in they land
 * on the page they asked for.
 */
const SignInFirst = ({ from }) => {
  const { openAuthModal, lastPublicPath } = useAuthModal();

  useEffect(() => {
    openAuthModal({ redirectTo: from });
  }, [from, openAuthModal]);

  return <Navigate to={lastPublicPath.current || "/"} replace />;
};

const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, loading } = useAuth();
  const location = useLocation();

  // Wait for auth check to complete
  if (loading) {
    return null; // or a loading spinner
  }

  if (!isAuthenticated) {
    return <SignInFirst from={`${location.pathname}${location.search || ""}`} />;
  }

  return children;
};

export default ProtectedRoute;
